import React from "react";
import { describePath, formatChangeValue } from "./changeLabels";

// The field-by-field list of changes between two plan contents (publish diff and compare).
const ChangesTable = ({ changes, currency = "INR", emptyText = "No changes." }) => {
  if (!changes || changes.length === 0) {
    return <p className="warranty-help" style={{ float: "none" }}>{emptyText}</p>;
  }
  return (
    <table className="warranty-changes">
      <thead>
        <tr>
          <th scope="col">Field</th>
          <th scope="col">Before</th>
          <th scope="col">After</th>
        </tr>
      </thead>
      <tbody>
        {changes.map((change) => {
          const added = change.before === undefined;
          const removed = change.after === undefined;
          return (
            <tr key={change.path}>
              <th scope="row">{describePath(change.path)}</th>
              <td className={removed ? "is-removed" : ""}>
                {added ? <span className="warranty-muted">Not set</span> : formatChangeValue(change.path, change.before, currency)}
              </td>
              <td className={added ? "is-added" : ""}>
                {removed ? <span className="warranty-muted">Removed</span> : formatChangeValue(change.path, change.after, currency)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ChangesTable;
